import Highcharts from "highcharts";

/**
 * Genera un gráfico de Highcharts en un contenedor HTML.
 * @param {HTMLElement} container - Elemento HTML (ref) donde se renderiza el gráfico.
 * @param {Object} chartData - Objeto con datos del gráfico.
 * @param {String} chartType - Tipo de gráfico ("pie" o "column").
 */
export function renderGeoprocessingChart(container, chartData, chartType = "pie") {
  if (!container || !chartData) {
    console.warn("⚠️ No hay datos o contenedor para renderizar el gráfico");
    return;
  }

  try {
    // Detectar título dinámicamente (ej. "Total Buffer" o "Total Infra")
    const ignoredKeys = ["graphType", "availableLayers", "rawResults", "results_table", "filterGeometry", "population", "pdfReport"];
    const key = Object.keys(chartData).find(k => !ignoredKeys.includes(k));
    const bufferData = chartData[key] || [];
    const graphType = chartData.graphType || "InfluenciaRadial";

    // 💡 Generar los datos para Highcharts
    const seriesData = bufferData.map(d => {
      let label;
      if (["InfluenciaPoligonal", "InfluenciaLineal"].includes(graphType)) {
        label = d.layer_name || "Capa sin nombre";
      } else {
        label = d.radius ? `${d.radius} m` : d.name || "N/A";
      }
      return {
        name: label,
        y: d.percentage,
        cantidad: d.features_count,
      };
    });

    return Highcharts.chart(container, {
      chart: { type: chartType, backgroundColor: "transparent" },
      accessibility: { enabled: false },
      title: { text: null },
      tooltip: {
        useHTML: true,
        headerFormat: "",
        pointFormat:
          "<b>{point.name}</b><br>Porcentaje: <b>{point.y}%</b><br>Cantidad: <b>{point.cantidad}</b>",
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: { enabled: true, format: "{point.name}" },
          showInLegend: true,
        },
        column: {
          borderRadius: 3,
          colorByPoint: true,
          dataLabels: { enabled: true, format: "{point.y}%" },
          showInLegend: true,
        },
        series: { states: { inactive: { opacity: 0.5 } } },
      },
      legend: {
        enabled: true,
        align: "center",
        verticalAlign: "bottom",
        layout: "horizontal",
        itemStyle: {
          fontSize: "13px",
          color: "#333",
          fontWeight: "500",
          cursor: "pointer",
        },
        itemHoverStyle: { color: "#006FB3" },
      },
      credits: { enabled: false },
      series: [
        { name: "Porcentaje", colorByPoint: true, data: seriesData },
      ],
    });
  } catch (err) {
    console.error("❌ Error al renderizar gráfico:", err);
  }
}
